export default "__VITE_ASSET__ebce0b38__"